import { useMutation, useQueryClient } from "react-query";
import editBudgetGroupHandler from "./handlers/editBudgetGroupHandler";
import editBudgetGroupResponder from "./responders/editBudgetGroupResponder";

const useEditBudgetGroup = () => {
  const queryClient = useQueryClient();

  const editMutation = useMutation(
    editBudgetGroupHandler,
    editBudgetGroupResponder(queryClient)
  );

  const editBudgetGroup = async (props) => {
    if (!props.group || !props.budgetLastUpdated || !props.budgetId) {
      console.error(
        "budgetId, group, budgetLastUpdated is required: populate with the original version of the item you are updating"
      );

      return null;
    }

    const response = await editMutation.mutateAsync(props);
    return response;
  };

  const {
    isLoading: isEditGroupLoading,
    isError: isEditGroupError,
    error: editGroupError,
    isSuccess: editGroupSuccess,
  } = editMutation;

  return {
    editBudgetGroup,
    isEditGroupLoading,
    isEditGroupError,
    editGroupError,
    editGroupSuccess,
  };
};

export default useEditBudgetGroup;
